<template>
  <OrderTestDialog
    class="x-choose-y-dialog"
    :title="title"
    :is-show-dialog="isShowDialog"
    :width="width"
    @close="close"
  >
    <slot name="banner"></slot>
    <div v-if="isShowChooseLater" class="flex justify-between mb-3">
      <slot name="choose-later-text">
        <p>{{ tFunction("OrderPage[\"choose test\"]") }} <span class="font-bold">{{ tFunction("OrderPage[\"later\"]") }}</span>:</p>
      </slot>
      <el-switch v-model="isChooseLater" />
    </div>
    <div v-if="!isChooseLater">
      <p>{{ chooseText }}</p>
      <div :class="['grid gap-x-2 gap-y-3 grid-cols-3']">
        <div 
          v-for="test in testList"
          :key="test.id" 
          :class="[
            'bundle-card-container items-center cursor-pointer flex flex-row justify-between',
            { 'not-allowed-select' : test[isNotAllowedSelectProp] || (testList.filter(t => t.isSelectForXChooseY).length === testQuantity && !test.isSelectForXChooseY) || !isAllowedForPatientAge(test) },
            { 'select-card': test.isSelectForXChooseY },
          ]"
          @click="handleClickTest(test)"
        >
          <!-- <span v-if="!test.isSelectForXChooseY" class="material-icons-outlined uncheck-box">check_box_outline_blank</span> -->
          <!-- <img src="@/assets/orderTest/Checkbox(all).svg" alt="checked icon" class="checked-box"> -->
          <div class="flex items-center gap-1">
            <p class="ml-3 test-text font-medium" :class="{'test-name-with-icon': !isAllowedForPatientAge(test)}">{{ getItemNameByLanguage(test) }}</p>
            <el-popover v-if="!isAllowedForPatientAge(test)" placement="top-start" popper-class="display-full-name-popover" :width="272">
              <p class="dbs-popover-info">{{ tFunction("OrderPage[\"Reminder: The patient must be 14 or older to order this test\"]") }}</p>
              <template v-slot:reference>
                <svg class="hoverable-icon" @click.stop xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                  <path d="M20.7014 10C20.7014 15.5228 16.2243 20 10.7014 20C5.17857 20 0.701416 15.5228 0.701416 10C0.701416 4.47715 5.17857 0 10.7014 0C16.2243 0 20.7014 4.47715 20.7014 10Z" fill="#FF1D00" fill-opacity="0.1"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M10.7014 18.75C15.5339 18.75 19.4514 14.8325 19.4514 10C19.4514 5.16751 15.5339 1.25 10.7014 1.25C5.86892 1.25 1.95142 5.16751 1.95142 10C1.95142 14.8325 5.86892 18.75 10.7014 18.75ZM10.7014 20C16.2243 20 20.7014 15.5228 20.7014 10C20.7014 4.47715 16.2243 0 10.7014 0C5.17857 0 0.701416 4.47715 0.701416 10C0.701416 15.5228 5.17857 20 10.7014 20Z" fill="#FF1D00"/>
                  <path d="M15.83 12.1555V7.75562H16.9424V12.1555H15.83ZM14.1863 10.5117V9.39935H18.5861V10.5117H14.1863Z" fill="black"/>
                  <path d="M7.90186 12.0063V10.9467L10.5585 6.76123H11.4721V8.22785H10.9314L9.25661 10.8783V10.928H13.0319V12.0063H7.90186ZM10.9563 13.1249V11.6831L10.9811 11.2139V6.76123H12.2427V13.1249H10.9563Z" fill="black"/>
                  <path d="M6.48577 6.76147V13.1251H5.14034V8.03855H5.10305L3.64575 8.95208V7.7589L5.22112 6.76147H6.48577Z" fill="black"/>
                </svg>
              </template>
            </el-popover>
          </div>
          <p class="mr-3 test-text">{{ currency.symbol + test.price }}</p>
        </div>
      </div>
      <div v-if="supplementList.length > 0">
        <p class="mt-3">{{ tFunction("OrderPage[\"Select add-on:\"]") }}</p>
        <div class="grid grid-cols-3 gap-x-2 gap-y-3">
          <div 
            v-for="supplement in supplementList"
            :key="supplement.id" 
            :class="[
              'bundle-card-container flex items-center pl-3 cursor-pointer',
              { 'not-allowed-select': supplement[isNotAllowedSelectProp] || (supplementList.filter(s => s.isSelectForXChooseY).length === supplementQuantity && !supplement.isSelectForXChooseY) },
              { 'select-card': supplement.isSelectForXChooseY },
            ]"
            @click="handleClickTest(supplement)"
          >
            <!-- <span v-if="!supplement.isSelectForXChooseY" class="material-icons-outlined uncheck-box">check_box_outline_blank</span> -->
            <!-- <img v-else src="@/assets/orderTest/Checkbox(all).svg" alt="checked icon" class="checked-box"> -->
            <p class="ml-3 test-text">{{ getItemNameByLanguage(supplement) }}</p>
          </div>
        </div>
      </div>
    </div>
    <template #buttons>
      <slot name="buttons">
        <LoginButton 
          class="ml-6 px-6" 
          type="primary" 
          @click="handleDone"
          :disabled="selectedTestQuantity < testQuantity"
        >
          {{ handleDoneButtonText }}
        </LoginButton>
        <LoginButton class="w-36" @click="close">{{ tFunction("OrderPage[\"Cancel\"]") }}</LoginButton>
      </slot>
    </template>
  </OrderTestDialog>
</template>

<script>
import OrderTestDialog from "../components/OrderTestDialog.vue";
import LoginButton from "@/views/login/components/LoginButton.vue";
import { isItemAllowedForPatientAge } from "./custom-panel/customPanelCard";
import { mapGetters, mapState } from "vuex";
import { getItemNameByLanguage } from "./order-test-panel/order-test-tabs/testCard";
import { tFunction } from "@/i18n.js";

export default {
  emits: ["close", "handleDone"],
  components: {
    OrderTestDialog,
    LoginButton
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    isShowDialog: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 724
    },
    isShowChooseLater: {
      type: Boolean,
      default: false
    },
    chooseText: {
      type: String,
      default: ""
    },
    selectProp: {
      type: String,
      default: "isSelect"
    },
    isNotAllowedSelectProp: {
      type: String,
      default: "isNotAllowedSelect"
    },    
    testList: {
      type: Array,
      default: () => []
    },
    testQuantity: {
      type: Number,
      default: 0
    },
    supplementList: {
      type: Array,
      default: () => []
    },
    supplementQuantity: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      isChooseLater: false,
      selectedTestIdList: [],
    }
  },

  computed: {
    ...mapState(["currency", "language"]),
    ...mapState("orderTest", ["isDbsVersion", "discountMap", "dbsMap"]),
    ...mapState("orderTest/exceptions", ["exceptionMap"]),
    ...mapGetters("orderTest", ["orderTestSupportObj"]),
    ...mapGetters("orderTest/tests", ["bfsTestList", "vwTestList"]),
    ...mapGetters("orderTest/panels", ["bundleList"]),
    ...mapGetters("orderTest/order", ["patientAge"]),
    ...mapState("orderTest/panels", ["discountPanelList"]),

    selectedTestQuantity() {
      return this.testList.filter(t => t.isSelectForXChooseY).length;
    },

    remainingTestQuantity() {
      return this.testQuantity - this.selectedTestQuantity;
    },
    handleDoneButtonText() {
      if (this.remainingTestQuantity > 0) {
        return this.$t("OrderPage[\"Add ${this.remainingTestQuantity} to continue\"]", { remainingTestQuantity: this.remainingTestQuantity });
      }
      return this.$t("OrderPage[\"Add to Cart\"]");
    },

  },

  methods: {
    tFunction,
    
    handleClickTest(test) {
      test.isSelectForXChooseY = !test.isSelectForXChooseY;
    },
    handleDone() {
      // for choose test later
      if (this.isChooseLater) {
        this.$emit("handleDone", { 
          selectedTestIdList: [],
          selectedSupplementIdList: []
        });
        return;
      }
      let selectedTestIdList = this.testList.filter(test => test.isSelectForXChooseY)
        .map(test => test.id);
      let selectedSupplementIdList = this.supplementList
        .filter(supplement => supplement.isSelectForXChooseY)
        .map(supplement => supplement.id);
      this.$emit("handleDone", { selectedTestIdList, selectedSupplementIdList });
      // initialize switch value
      this.isChooseLater = false;
    },
    isAllowedForPatientAge(test) {
      return isItemAllowedForPatientAge(test, this.orderTestSupportObj, this.patientAge);
    },

    getItemNameByLanguage(test) {
      return getItemNameByLanguage(test, this.language);
    },
    close() {
      this.$emit("close");
    }
  }
}
</script>

<style scoped>
.bundle-card-container {
  min-height: 46px;
  background: #F9FBFD;
  box-shadow: 0px 2px 6px rgba(48, 48, 48, 0.13);
  border-radius: 3.23482px;
}

.test-text {
  font-family: 'Roboto';
  font-style: normal;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0.15px;
  color: rgba(0, 0, 0, 0.87);
}

.uncheck-box {
  font-size: 20px;
}
.not-allowed-select {
 pointer-events: none;
 background-color: #E6E6E6;
}

.select-card {
  border: 3px solid #3498db;
  border-radius: 3px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.5);
}


.hoverable-icon {
  pointer-events: auto;
  cursor: pointer;
}
</style>